import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigService } from './auth/config.service';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root',
})
export class AllotService {
  constructor(private http: HttpClient, private configService: ConfigService, private router: Router) { }
  // Method for get All List data
  getAllAllotAuditors(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetAllotDetailsList`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );

  }


  getRaiseAudit(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/FinalChecklist/GetAuditListbyAR`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );

  }

  // Method for Add Auditor
  addAllotAuditor(formData: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/Audit/AddAllotAuditor`;

    return this.http.post<any>(apiUrl, formData).pipe(
      map((response) => response),
      catchError((err) => {
        console.error('Error:', err);
        return throwError(() => new Error('Something went wrong while adding the auditor.'));
      })
    );
  }


  // Method for Add Auditor
  payment(paymentdata: any): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/CheckList/SocietyPayment`;

    return this.http.post<any>(apiUrl, paymentdata).pipe(
      map((response) => response),
      catchError((err) => {
        console.error('Error:', err);
        return throwError(() => new Error('Something went wrong while adding the auditor.'));
      })
    );
  }

  // Method to get auditor details
  getAllotAuditorDetails(iAllotAuditorID: number): Observable<any[]> {
    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetAllotAuditorRecord/${iAllotAuditorID}`;

    return this.http.get<any[]>(apiUrl);
  }
  // Method to get auditor status
  getAllotAuditorStatus(iSocietyDetailID: number, iAllotAuditorID: number): Observable<any[]> {
    const apiUrl = `${this.configService.getApiUrl()}/CheckList/SocietyAuditProgress/${iSocietyDetailID}/${iAllotAuditorID}`;

    return this.http.get<any[]>(apiUrl);
  }
  getAuditAssignDate(): Observable<any[]> {
    const apiUrl = `${this.configService.getApiUrl()}/Admin/GetAuditAssigndate`;
    return this.http.get<any[]>(apiUrl);
}

  // Function to call the backend API

  getDropDownAuditorList(id: number): Observable<any> {

    const apiUrl = `${this.configService.getApiUrl()}/Audit/GetDropDownAuditorList/${id}`;

    return this.http.get<any>(apiUrl);
  }



  // Method for Delete Allot Auditor
  deleteAudit(iAllotAuditorID: number): Observable<any> {

    const url = `${this.configService.getApiUrl()}/Audit/DeleteAllotAuditbyID/${iAllotAuditorID}`;

    return this.http.delete(url).pipe(
      catchError((error) => {
        console.error('Error deleting audit:', error);
        throw error;
      })
    );
  }
}